import angular from 'angular';
import booksService from '../../util/BooksSvc/BooksSvc';
import fundraiserReportTemplate from './fundraiserReport.template.html';

export default angular
  .module('books.ui.fundraiserReport', [booksService])
  .directive('fundraiserReport', fundraiserReportDirective).name;

/* reportOnOptions
  /* Array of options passed in from the controller.
   * The array expects the following: 
   * name            - displays in the report on dropdown
   * useTA           - enables/disables the typeahead
   * requestField    - part of the request object, identifies the property to be 
   *                   submitted in the request
   * valueField      - part of the request object. Identifies the property to be 
   *                   submitted in the request
   * action          - identifies the appropriate aspx report to be submitted. 
   * allowDetail     - enables/disables the report type radio buttons
   * 
   * reportOnOptions - Array of options to be displayed in the Report On dropdown
   * 
   * selectedReport  - the report selection made in the report on dropdown.
   * 
   */
/* @ngInject */
function fundraiserReportDirective(BooksSvc) {
  return {
    template: fundraiserReportTemplate,
    scope: {
      reportOnOptions: '=',
      selectedReport: '='
    },
    link: function ($scope, element, attr) {
      /*----------------------*/
      /* Sets default values. */
      /*----------------------*/
      $scope.req = {
        reportFormat: 'PDF',
        activeOnly: 'false',
        detailOnly: 'true',
        clubID: '-1',
        classID: '0',
        classType: '0'
      };

      /*------------------------------------------------*/
      /* Sets the default report to be the first one in */
      /* the reportOnOptions for the Report On field.   */
      /*------------------------------------------------*/
      $scope.data = { selectedReport: $scope.reportOnOptions[0] };

      /*---------------------------------------------------*/
      /* Works with the CSMValidator directive to validate */
      /* there is a selection in the typeahead and the end */
      /* date. Alert will pop up if there is an error.     */
      /*---------------------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /*--------------------------------------------*/
      /* Watches for changes in the Report On field */
      /*--------------------------------------------*/
      $scope.$watch('data.selectedReport', function (current, previous) {
        if (previous && previous.requestField != undefined)
          $scope.req[previous.requestField] = -1;

        $scope.data.optionObject = null;
        $scope.req.classType = current.classType;
        $scope.req.detailOnly = 'true';
      });

      /*---------------------------------------------------------*/
      /* Changes the array in the typeahead based on the changes */
      /* made in the Report On field with the watcher above.     */
      /*---------------------------------------------------------*/
      $scope.$watch('data.optionObject', function (obj) {
        if (
          !$scope.data.selectedReport ||
          $scope.data.selectedReport.requestField == undefined
        )
          return;

        $scope.req[$scope.data.selectedReport.requestField] = obj
          ? obj[$scope.data.selectedReport.valueField]
          : -1;
      });

      /*****************************************************************************
       * getOrganization */
      /**
       * Returns current organization information.
       *****************************************************************************/
      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;
      });
    }
  };
}
